// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Logo Section */
.style_logoSection__Vhcmv {
  display: flex;
  align-items: center;
}

.style_logoLink__eWpt9 {
  display: flex;
  align-items: center;
  text-decoration: none;
}

/* Navigation */
.style_navigation__ADl8v {
  display: flex;
  align-items: center;
  gap: 32px;

  @media (max-width: 1200px) {
    gap: 24px;
  }
}

/* Machines Button */
.style_machines_button__bqCik {
  background: none;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

.style_machines_button__bqCik:hover {
  color: var(--text-heading);
}

/* Avatar Button */
.style_avatar_button__y72c0 {
  background: none;
  padding: 4px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_avatar_button__y72c0:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.2);
  background-color: rgba(25, 118, 210, 0.05);
}

/* Popover Menu */
.style_menu__bcWmk {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  min-width: 200px;
}

.style_link_menu__AVRTB {
  text-decoration: none;
  font-size: 15px;
  font-weight: 400;
  color: var(--text-primary);
  padding: 10px 20px;
  transition: background-color 0.2s ease, color 0.2s ease;
  display: block;
}

.style_link_menu__AVRTB:hover {
  background-color: var(--table-row-alt);
  color: var(--text-heading);
}

/* Active state for menu links */
.style_link_menu_active__XDSbv {
  background-color: var(--table-header-bg);
  color: var(--text-heading);
  font-weight: 500;
}

/* Mobile Styles */
@media (max-width: 768px) {
  .style_navigation__ADl8v {
    display: none;
  }

  .style_logoLink__eWpt9 svg {
    height: 48px;
  }
}

/* Elevation on scroll effect */
.style_elevated__8qrSQ {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

/* Smooth transitions */
* {
  transition-property: background-color, color, border-color, box-shadow;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/style.module.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,SAAS;EACX;AACF;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,uDAAuD;EACvD,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,+BAA+B;AAC/B;EACE,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,sEAAsE;EACtE,yBAAyB;EACzB,gCAAgC;AAClC","sourcesContent":["/* Logo Section */\n.logoSection {\n  display: flex;\n  align-items: center;\n}\n\n.logoLink {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n}\n\n/* Navigation */\n.navigation {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n\n  @media (max-width: 1200px) {\n    gap: 24px;\n  }\n}\n\n/* Machines Button */\n.machines_button {\n  background: none;\n  padding: 0;\n  font-size: inherit;\n  font-family: inherit;\n  border: none;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n.machines_button:hover {\n  color: var(--text-heading);\n}\n\n/* Avatar Button */\n.avatar_button {\n  background: none;\n  padding: 4px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.avatar_button:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.2);\n  background-color: rgba(25, 118, 210, 0.05);\n}\n\n/* Popover Menu */\n.menu {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 0;\n  min-width: 200px;\n}\n\n.link_menu {\n  text-decoration: none;\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--text-primary);\n  padding: 10px 20px;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  display: block;\n}\n\n.link_menu:hover {\n  background-color: var(--table-row-alt);\n  color: var(--text-heading);\n}\n\n/* Active state for menu links */\n.link_menu_active {\n  background-color: var(--table-header-bg);\n  color: var(--text-heading);\n  font-weight: 500;\n}\n\n/* Mobile Styles */\n@media (max-width: 768px) {\n  .navigation {\n    display: none;\n  }\n\n  .logoLink svg {\n    height: 48px;\n  }\n}\n\n/* Elevation on scroll effect */\n.elevated {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n/* Smooth transitions */\n* {\n  transition-property: background-color, color, border-color, box-shadow;\n  transition-duration: 0.3s;\n  transition-timing-function: ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoSection": `style_logoSection__Vhcmv`,
	"logoLink": `style_logoLink__eWpt9`,
	"navigation": `style_navigation__ADl8v`,
	"machines_button": `style_machines_button__bqCik`,
	"avatar_button": `style_avatar_button__y72c0`,
	"menu": `style_menu__bcWmk`,
	"link_menu": `style_link_menu__AVRTB`,
	"link_menu_active": `style_link_menu_active__XDSbv`,
	"elevated": `style_elevated__8qrSQ`
};
export default ___CSS_LOADER_EXPORT___;
